import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken.jsx';

const uploadMedia = async (draftId, mediaName, mediaType, file) => {
  const formData = new FormData();
  const metadata = {
    name: mediaName,
    type: mediaType
  };
  formData.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
  formData.append('file', file);

  const handleResponse = (response) => {
    const data = response.data;
    console.log('Uploaded Metadata:', data);
    return data;
  };

  try {
    const accessToken = await retrieveAccessToken();
    const response = await axios.post(
        `/api/editor/draft/${draftId}/media`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${accessToken}`
          }
        }
    );
    return handleResponse(response);
  } catch (error) {
    console.error('Upload failed:', error);
    throw error;
  }
};

export { uploadMedia };
